import type { FC } from 'react'

export const ConversationHistorySkeletonLoader: FC = () => (
  <div className="my-2 flex animate-pulse flex-col gap-2 pl-2">
    <span className="h-6 w-full rounded-sm bg-dark" />
    <span className="h-6 w-full rounded-sm bg-dark" />
    <span className="h-6 w-full rounded-sm bg-dark" />
    <span className="h-6 w-full rounded-sm bg-dark" />
    <span className="h-6 w-full rounded-sm bg-dark" />
    <span className="h-6 w-full rounded-sm bg-dark" />
    <span className="h-6 w-full rounded-sm bg-dark" />
    <span className="h-6 w-full rounded-sm bg-dark" />
    <span className="h-6 w-full rounded-sm bg-dark" />
    <span className="h-6 w-full rounded-sm bg-dark" />
  </div>
)
